var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOffer = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.7,
  fillRule: "evenodd",
  d: "M1 11.286C1 5.58 5.968 1 12 1c5.991 0 11 4.577 11 10.286 0 5.756-5.012 10.285-11 10.285-1.436 0-2.778-.255-4.02-.7C6.818 21.816 4.864 23 2.313 23h-.04C1.444 23 1 22.289 1 21.687v-.009c0-.046-.002-.211.033-.372.037-.168.12-.373.287-.549l.024-.033.023-.031c.044-.06.098-.133.162-.224.152-.212.358-.51.578-.874.375-.619.773-1.392 1.02-2.211A9.706 9.706 0 0 1 1 11.286ZM12 3C6.94 3 3 6.813 3 11.286c0 1.982.728 3.798 1.97 5.179l.345.383-.112.504c-.287 1.288-.885 2.454-1.386 3.28a14.92 14.92 0 0 1-.131.213c1.539-.349 2.719-1.218 3.42-1.86l.47-.43.59.245A9.905 9.905 0 0 0 12 19.57c5.028 0 9-3.774 9-8.285C21 6.816 17.025 3 12 3Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.7,
  fillRule: "evenodd",
  d: "M12 5.15a.75.75 0 0 0-.75.75v1.25h-.5a2.5 2.5 0 0 0 0 5h.5v2H9a.75.75 0 0 0 0 1.5h2.25v1.25a.75.75 0 0 0 1.5 0v-1.25h.5a2.5 2.5 0 0 0 0-5h-.5v-2h1.75a.75.75 0 0 0 0-1.5h-1.75V5.9a.75.75 0 0 0-.75-.75Zm-1.25 3.5h.5v2h-.5a1 1 0 0 1 0-2Zm2 5.5v-2h.5a1 1 0 1 1 0 2h-.5Z",
  clipRule: "evenodd"
})));
SvgOffer.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgOffer);
export default ForwardRef;